import { useState, useEffect } from 'react';
import _ from 'lodash';
import getFormLocal from './getFormLocal';
import useValue from './useValue';

export default function useConditionalDisplay(removeConditions, elementIds, question) {
  const [display, setDisplay] = useState('loading');
  const { formId, sectionId, questionId } = elementIds;

  // on sauvegarde la valeur dans le form pour savoir faire le check des questions rempli ou vide
  const [, setDisplayed] = useValue(formId, sectionId, questionId, question.type, 'displayed');

  const check = async () => {
    const form = await getFormLocal(formId);
    const res = Object.keys(removeConditions).map((removeCondition) => {
      const [sectionRemove, questionRemove] = removeCondition.split('.');
      const path = `inspection.children.${sectionRemove}.children.${questionRemove}.value`;
      if (removeConditions[removeCondition].includes(_.get(form, path, null))) return true;
      return false;
    });
    if (res.some((i) => i === true)) {
      setDisplay(false);
      setDisplayed(false);
      return;
    }
    setDisplay(true);
    setDisplayed(true);
  };

  const handleRefresh = async (e) => {
    if (Object.keys(removeConditions).includes(e.key)) {
      await check();
    }
  };

  // event listener for the list display and init value
  useEffect(() => {
    if (removeConditions && removeConditions !== null && removeConditions !== undefined) {
      window.addEventListener('storage', handleRefresh);
      check();
    } else if (question.displayed === false) setDisplay(false);
    else setDisplay(true);
    return () => {
      window.removeEventListener('storage', handleRefresh);
    };
  }, [removeConditions]);

  return [display];
}
